import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';

import { api } from './api/api-client.config';
import { getStorageItem, setStorageItem } from './lib/localStorage';
import Router from './routes';
import ThemeProvider from './theme';
import ScrollToTop from './components/scroll-to-top';
import { StyledChart } from './components/chart';
import LoginPage from './pages/LoginPage';
import { StorageKeys } from './enums/StorageKeys.enum';

export default function App() {
  const [searchParams] = useSearchParams();
  const [showLogin, setShowLogin] = useState(false);
  const [loading, setLoading] = useState(true);

  const accessToken = getStorageItem(StorageKeys.token);
  const token = searchParams.get('token');

  useEffect(() => {
    // If there is an access token, show the dashboard
    if (accessToken) {
      setLoading(false);
      return;
    }

    // If there is no token, show the login page
    if (!token) {
      setLoading(false);
      setShowLogin(true);
      return;
    }

    // If there is a token, try to login with it
    api
      .post<{ token: string }, { token: string; name: string; role: string }>(
        `/admin/login-with-token`,
        {
          token,
        }
      )
      .then((data) => {
        setStorageItem(StorageKeys.token, data.token);
        setStorageItem(StorageKeys.name, data.name);
        setStorageItem(StorageKeys.role, data.role);
        setLoading(false);

        searchParams.delete('token');
        window.location.reload();
      })
      .catch((error) => {
        console.error('Login error:', error);
        setLoading(false);
        setShowLogin(true);
      });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  if (showLogin) {
    return (
      <ThemeProvider>
        <LoginPage />
      </ThemeProvider>
    );
  }

  return loading ? (
    <Box
      sx={{ display: 'flex', justifyContent: 'center' }}
      style={{ padding: 220 }}
    >
      <CircularProgress />
    </Box>
  ) : (
    <ThemeProvider>
      <ScrollToTop />
      <StyledChart />
      <Router />
    </ThemeProvider>
  );
}
